import { fetchCase, getCases } from '../cases/actions';
import {
  getCaseSubType,
  validateRouteToRedirect,
  getQueryStringValueByName,
  isBackNavigation
} from '../../utils';
import moment from 'moment';
import { getToken, updateCSSLoading } from './actions';
import {
  CASE_TYPE_EXISTING,
  CASE_ID,
  DEFAULT_BANK,
  ROUTE_USERNAME_PASSWORD_PAGE,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  BDD_REVIEW_PAGE,
  ROUTE_REVIEW_PAGE,
  BANK_ID,
  OFFER_CASE_ID,
  ROUTE_OFFER_SECTION,
  DECLINE,
  AUTH_PAGE_KEY,
  CUSTOMER_UUID,
  GET_NEXT_DEF,
  USERNAME_PASSWORD,
  GET_NEXT_CREDIT_CHECK,
  CASE_SUBTYPE,
  CASE_TYPE_NTB,
  CSS_LOADER_DELAY,
  SAVE_AND_RESUME_CAPTURE,
  OFIICER_KEY,
  RESUME_KEY
} from '../../utils/constants';
import { retrieveOffers } from '../offers';
import { getExistingUser } from '../../store/dataCapture';
import { fetchCustomerById, getCustomer } from '../customers';
import { GET_NEXT_TASK_URI_KEYS } from '../offers/action.helper';
import * as analytics from '../../utils/analytics';
import { resumeType } from '../config/selectors';
const DATE_FORMAT_PDF_API = 'DD/MM/YYYY';
const REDIRECTION_PAGES = [
  ROUTE_USERNAME_PASSWORD_PAGE,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  BDD_REVIEW_PAGE,
  ROUTE_REVIEW_PAGE,
  AUTH_PAGE_KEY,
  ROUTE_OFFER_SECTION,
  DECLINE
];

export const dispatchNextAction = (state, ihsUrl) => dispatch => {
  let isLoder = false;
  analytics.initialize({
    brandName: state.config.get('brand_id')
  });

  if (getCaseSubType(state) === CASE_TYPE_EXISTING && !isValidPage(REDIRECTION_PAGES)) {
    showHideDocument(false);
    dispatch(getToken());
    isLoder = true;
  } else {
    updateBankStyle(state.config.get(BANK_ID) || DEFAULT_BANK, dispatch);
    isLoder = isFetchCaseRequired(state, dispatch);
  }
  if (isFetchCase()) {
    processUser(dispatch, state);
  }
};

export const getFileName = list =>
  list.filter(v => {
    const now = moment();
    const date_to = moment(v.date_to, DATE_FORMAT_PDF_API);
    const date_from = moment(v.date_from, DATE_FORMAT_PDF_API);
    return now.isAfter(date_from) && now.isBefore(date_to);
  });

export const updateBankStyle = (bank_id, dispatch) => {
  showHideDocument(false);

  //@TODOxCYBG: setTimeout is NOT a good solution but it will have to do until we refactor the CSS loading logic
  setTimeout(() => {
    dispatch(updateCSSLoading(true));
    showHideDocument(true);
  }, CSS_LOADER_DELAY);
};

export const isFetchCaseRequired = (state, dispatch) => {
  if (isFetchCase() && (state.config.get(CASE_ID) || state.config.get(OFFER_CASE_ID))) {
    if (validateRouteToRedirect(ROUTE_OFFER_SECTION) && state.config.get(OFFER_CASE_ID)) {
      dispatch(retrieveOffers());
    }
    dispatch(fetchCase());
    const cust_id = state.config.get(CUSTOMER_UUID);
    if (cust_id) {
      dispatch(fetchCustomerById(state.config.get(CUSTOMER_UUID), OFIICER_KEY));
    }
  } else {
    return false;
  }
};

export const processGetCustomer = dispatch => {
  if (!isValidPage(GET_NEXT_TASK_URI_KEYS)) {
    dispatch(getCustomer());
  }
};

export const showHideDocument = isVisible => {
  const ele = document.getElementsByName('body');
  if (ele && ele.length > 0 && ele[0].style) {
    ele[0].style.visibility = isVisible ? 'visible' : 'hidden';
  }
};

export const isValidPage = list => list.some(page => validateRouteToRedirect(page));

const processUser = (dispatch, state) => {
  if (
    state.config.get(CASE_ID) ||
    validateRouteToRedirect(ROUTE_REVIEW_PAGE) ||
    isValidPage([GET_NEXT_DEF, GET_NEXT_CREDIT_CHECK])
  ) {
    dispatch(getExistingUser());
  } else if (
    !isBackNavigation() &&
    validateRouteToRedirect(ROUTE_USERNAME_PASSWORD_PAGE) &&
    getQueryStringValueByName(CASE_SUBTYPE) === CASE_TYPE_NTB
  ) {
    dispatch(fetchCustomerById(state.config.get(CUSTOMER_UUID), USERNAME_PASSWORD));
  }
};

const isFetchCase = () =>
  isValidPage(GET_NEXT_TASK_URI_KEYS.concat(SAVE_AND_RESUME_CAPTURE)) ||
  validateRouteToRedirect(ROUTE_ACCOUNT_DETAILS_PAGE) ||
  validateRouteToRedirect(ROUTE_USERNAME_PASSWORD_PAGE) ||
  (validateRouteToRedirect(BDD_REVIEW_PAGE) && isBackNavigation()) ||
  (validateRouteToRedirect(ROUTE_REVIEW_PAGE) && !isBackNavigation());

export const isResumeCase = (state, dispatch) => {
  if (resumeType(state) === RESUME_KEY) {
    dispatch(getCases());
  }
};
